import React from 'react';
import { ChatProps } from './types';
import { ChatWidget } from './ChatWidget';

export const Chat: React.FC<ChatProps> = ({ digitalMapId }) => {
  return <ChatWidget digitalMapId={digitalMapId} />;
};
